import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { Wrapper, InputGroup, Label, Input, Buttons, Button } from "./styled";

const Row = ({ data, rowIdx, handleSave, onClose, intl }) => {
  const [values, setValues] = useState(data);

  const onChange = (key, value) => {
    setValues({ ...values, [key]: value, rowIdx: rowIdx + 1 });
  };

  const save = () => {
    handleSave({ rowIdx, data: values });
  };

  return (
    <Wrapper>
      <InputGroup>
        <Label>Namn</Label>
        <Input
          value={values.name || ""}
          onChange={(e) => onChange("name", e.target.value)}
        />
      </InputGroup>
      {/* Add any other settings you want to include here */}
      <Buttons>
        <Button onClick={onClose}>
          {intl.formatMessage({ id: "Cell.Settings.cancel" })}
        </Button>
        <Button onClick={save}>
          {intl.formatMessage({ id: "Cell.Settings.save" })}
        </Button>
      </Buttons>
    </Wrapper>
  );
};

export default injectIntl(Row);
